import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { ISettingsEmailsItemPayload, ISettingsEmailsItemResponse } from '../types';
import {
  ADMIN_GENERAL_SETTINGS_EMAILS_PERMISSIONS,
  SETTINGS_EMAIL_ITEM_QUERY_KEY,
  SETTINGS_EMAIL_ITEM_URL,

} from '../constants';

export default function useSettingsEmailItemQuery(
  payload: Ref<ISettingsEmailsItemPayload | undefined>,
): IContextQueryResult<ISettingsEmailsItemResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<ISettingsEmailsItemResponse, Error>({
    queryKey: [SETTINGS_EMAIL_ITEM_QUERY_KEY, payload],
    queryFn: ({ signal }) => fetchGet(SETTINGS_EMAIL_ITEM_URL, {
      signal,
      queryParams: payload.value,
      permission: ADMIN_GENERAL_SETTINGS_EMAILS_PERMISSIONS.MAILERS_MANAGER_EDIT,
    }),
    enabled: computed(() => !!payload.value),
  });
}
